import { Radio, RadioTower } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useWebSocketContext } from './WebSocketProvider'
import { liveStatusView } from '@/lib/liveLink'
import { cn } from '@/lib/utils'

// #328 — the live status (one source of truth with the header's dot, LiveIndicator): green when live, amber
// while reconnecting (also while the first connection is made), grey when off. It used to follow the socket
// being open (green "Alerts Live" / red "Alerts Off"), which stayed green on a dead connection.
const PILL_COLOUR = {
  live: 'bg-green-500/10 text-green-600 dark:text-green-400',
  reconnecting: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  offline: 'bg-gray-500/10 text-gray-500 dark:text-gray-400',
} as const

export function WebSocketStatus() {
  const { t } = useTranslation('common')
  const { status } = useWebSocketContext()
  const view = liveStatusView(status)
  const label = t(`live.${view}`)

  return (
    <div
      data-live-status={view}
      className={cn(
        'flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-colors',
        PILL_COLOUR[view],
      )}
      title={label}
    >
      {view === 'live' ? (
        <>
          <span className="relative flex h-2 w-2">
            <span className="animate-pulse inline-flex h-2 w-2 rounded-full bg-green-500 opacity-75" />
          </span>
          <Radio className="h-3 w-3" />
        </>
      ) : (
        <RadioTower className={cn('h-3 w-3', view === 'reconnecting' && 'animate-pulse')} />
      )}
      <span className="hidden sm:inline">{label}</span>
    </div>
  )
}
